import { Alert, AlertTitle } from '@mui/material';
import styled, { css, keyframes } from 'styled-components';
import { SPACING } from '~/common/constants/spacing';
import { Z_INDEX } from '~/common/constants/z-index';

export const StyContainer = styled.div`
  position: fixed;
  top: ${SPACING._20};
  right: ${SPACING._20};
  width: fit-content;
  display: flex;
  flex-direction: column;
  gap: ${SPACING._8};
  z-index: ${Z_INDEX.ALERT_TOAST};
`;

const slideIn = keyframes`
  0% {
    transform: translateX(400px);
    animation-timing-function: ease-out;
  }
  60% {
    transform: translateX(-30px);
    animation-timing-function: ease-in;
  }
  80% {
    transform: translateX(10px);
    animation-timing-function: ease-out;
  }
  100% {
    transform: translateX(0px);
    animation-timing-function: ease-in;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

interface IStyToast {
  readonly $isOpen: boolean;
  readonly color: string;
}

export const StyToast = styled.div<IStyToast>`
  display: flex;
  flex-direction: column;
  gap: ${SPACING._4};
  align-items: flex-start;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  opacity: 1;
  animation: ${slideIn} 0.8s ease-in-out;

  ${({ $isOpen }) =>
    !$isOpen &&
    css`
      animation: ${fadeOut} 0.4s ease-out forwards;
    `}
`;

export const StyAlert = styled(Alert)`
  width: 500px;
  max-width: calc(100vw - ${SPACING._40});
`;

interface IStyAlertTitle {
  $hasDescription?: boolean;
}

export const StyAlertTitle = styled(AlertTitle)<IStyAlertTitle>`
  ${({ $hasDescription }) =>
    !$hasDescription &&
    css`
      font-size: 16px !important;
      line-height: 1.25 !important;
      margin-bottom: 0 !important;
      margin-top: 0 !important;
    `}
`;
